
function setup(field) {
    const label = field.querySelector('label')
    const input = field.querySelector(`#${label.getAttribute('for')}`)

    const original = label.innerHTML

    if (input) {
        input.addEventListener('change', (e) => {
            const file = e.target.files[0]
            if (file) {
                label.textContent = file.name
            } else {
                label.innerHTML = original
            }
        })
    }

}

function main() {
    const fields = Array.from(document.querySelectorAll('.form-element__form .field.file'))

    if (!fields.length) return;
    fields.forEach(setup)
}

main()
